export const preventDefaultMouseTouchEvents = (el: HTMLElement) => {
    el.addEventListener("mousedown", (e) => e.preventDefault(), false);
    el.addEventListener("mouseup", (e) => e.preventDefault(), false);
    el.addEventListener("mouseout", (e) => e.preventDefault(), false);
    el.addEventListener("mousemove", (e) => e.preventDefault(), false);
    el.addEventListener("touchstart", (e) => e.preventDefault(), false);
    el.addEventListener("touchmove", (e) => e.preventDefault(), false);
    el.addEventListener("touchend", (e) => e.preventDefault(), false);
}